// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5mZY8","footer":"styles_footer__m5P7V","passCodeTooltip":"styles_passCodeTooltip__kFn-p"};